import {Injectable} from '@angular/core';
import {StripeElementsOptionsClientSecret} from '@stripe/stripe-js/types/stripe-js/elements-group';
import {StripePaymentElementOptions} from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class StripeNewCcConfigService {
  getElementsOptions(clientSecret: string, allowedCardBrands: string[] = undefined): StripeElementsOptionsClientSecret {
    return {
      allowedCardBrands,
      loader: 'never',
      appearance: {
        disableAnimations: true,
        theme: 'flat',
        variables: {
          fontFamily: 'BentonSans',
          borderRadius: '4px',
        },
        rules: {
          '.Input::placeholder': {
            color: '#475E75',
          },
          '.Input:focus': {
            color: '#223548',
            borderColor: '#0040B0',
            boxShadow: '0',
          },
          '.Input': {
            color: '#223548',
            borderColor: '#5B738B',
          },
          '.Input--invalid': {
            color: '#223548',
            boxShadow: '0 0 0 1px #EE3939',
          },
          '.Error': {
            color: '#EE3939'
          }
        }
      },
      clientSecret,
      locale: 'en',
    } as any; // allowedCardBrands beta property is not exposed by API definition
  };

  getPaymentElementOptions(): StripePaymentElementOptions {
    return {
      terms: {
        card: 'never'
      },
      fields: {
        billingDetails: {
          address: {
            country: 'auto'
          }
        }
      },
    };
  }
}
